import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class EarthquakeReinforcementsDto extends InspectionCase {
  pipelineIntervalsAccordingSpec?: InspectionCase;
  flexibleCouplingsAccordingSpec?: InspectionCase;
  earthquakeBracesAccordingSpec?: InspectionCase;
}

export class EarthquakeReinforcements extends EarthquakeReinforcementsDto {
  constructor(
    data: EarthquakeReinforcementsDto = {
      title: 'חיזוקים לרעידות אדמה'
    }
  ) {
    super(data);
    this.pipelineIntervalsAccordingSpec = new InspectionCase({
      ...data.pipelineIntervalsAccordingSpec,
      title: `כל הצנרת הותקנה עם מרווחים ( Clearance ) הנדרשים בתקן`
    });
    this.flexibleCouplingsAccordingSpec = new InspectionCase({
      ...data.flexibleCouplingsAccordingSpec,
      title: `הותקנו מחברים גמישים (Flexible Couplings) במקומות הנדרשים בתקן`
    });
    this.earthquakeBracesAccordingSpec = new InspectionCase({
      ...data.earthquakeBracesAccordingSpec,
      title: `הותקנו חיזוקים נגד רעידות אדמה (Braces ) על פי התכנון (אורך , קוטר , עובי דופן של החיזוק ,זווית ההתקנה של החיזוק אביזר חיבור לקונסטרוקציה של המבנה ואביזר חיבור לצינור)`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.pipelineIntervalsAccordingSpec.isApplicable ||
        this.pipelineIntervalsAccordingSpec.isPassed) &&
        (!this.flexibleCouplingsAccordingSpec.isApplicable ||
          this.flexibleCouplingsAccordingSpec.isPassed) &&
        (!this.earthquakeBracesAccordingSpec.isApplicable ||
          this.earthquakeBracesAccordingSpec.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.pipelineIntervalsAccordingSpec.getNotes(),
      ...this.flexibleCouplingsAccordingSpec.getNotes(),
      ...this.earthquakeBracesAccordingSpec.getNotes()
    ];
  }
}
